module.exports = "https://static.wanderu.com/static/media/homescreen-iphone2x.430d3b99.png";